module.exports = __webpack_public_path__ + "static/img/bdh.00f8f09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/bdh.jpg
// module id = m0rB
// module chunks = 0